// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import StationPage from '../StationPage'
import { i18n } from '../../../index'
import { Mutation, Query } from 'react-apollo'
import { fetchSettings, toggleStationSettings } from './settingsQueries'
import _ from 'lodash'
import { Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import Loader from '../../../../common/loader/Loader'
import StationCheckQuestionSection from '../../checkQuestion/StationCheckQuestionSection'
import css from './stationSettings.css'
export type Setting = {
  id: string
  name: string
  type: string
  category: string
}

const StationSettingsPage = () => {
  // When arriving with a #hash (e.g. from the "Muokkaa" shortcut on the checklist),
  // scroll to that section once it has rendered. The section loads asynchronously,
  // so retry for a short while until the element exists.
  React.useEffect(() => {
    const hash = window.location.hash
    if (!hash) {
      return
    }
    const targetId = hash.replace('#', '')
    let attempts = 0
    const timer = setInterval(() => {
      const el = document.getElementById(targetId)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        clearInterval(timer)
      } else if (++attempts > 40) {
        // give up after ~10s
        clearInterval(timer)
      }
    }, 250)
    return () => clearInterval(timer)
  }, [])

  const onSettingsToggle = (onMutate: (...args: Array<any>) => any) => {
    onMutate()
  }

  return (
    <StationPage title={i18n.t('admin.stations.title.settings')}>
      {({ station }) => (
        <Query
          query={fetchSettings}
          variables={{
            stationId: station.id,
          }}
          fetchPolicy={'network-only'}
        >
          {({ loading, data, error }) => {
            const settings: Setting[] = _.get(data, 'settings', [])

            if (settings.length === 0) {
              return (
                <Paper className={css.noResultsPaper}>
                  <Typography variant={'h6'}>{i18n.t('admin.stations.label.noSettings')}</Typography>
                </Paper>
              )
            }

            const groupedSettings: Setting[] = _.groupBy(settings, 'category')

            const stationSettings = _.get(data, 'stationSettings', [])

            const sortedSettings = Object.keys(groupedSettings)
              .sort()
              .reduce((acc, cur) => {
                acc[cur] = _.sortBy(groupedSettings[cur], ['name'])
                return acc
              }, {})
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <>
                  <Paper className={css.component}>
                    {Object.keys(sortedSettings).map((category) => (
                      <div key={category} className={css.settingsGroup}>
                        <Typography variant={'subtitle1'}>
                          {i18n.t(`admin.stations.label.settings.${category}`)}
                        </Typography>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>{i18n.t('admin.stations.label.settingsName')}</TableCell>
                              <TableCell className={css.actionCell}>
                                {i18n.t('admin.stations.label.settingsToggled', {
                                  count: stationSettings.filter((s) => s.category === category).length,
                                })}
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {sortedSettings[category].map((settings) => {
                              const settingIsOn = _.find(stationSettings, ['name', settings.name])

                              return (
                                <TableRow key={settings.id}>
                                  <TableCell>{i18n.t(`admin.stations.label.settings.${settings.name}`)}</TableCell>
                                  <TableCell className={css.actionCell}>
                                    <Mutation
                                      mutation={toggleStationSettings}
                                      variables={{
                                        stationId: station.id,
                                        id: settings.id,
                                      }}
                                      refetchQueries={[
                                        {
                                          query: fetchSettings,
                                          variables: {
                                            stationId: station.id,
                                          },
                                        },
                                      ]}
                                    >
                                      {(onMutate) => (
                                        <Switch
                                          checked={!!settingIsOn}
                                          color={'primary'}
                                          onChange={() => onSettingsToggle(onMutate)}
                                        />
                                      )}
                                    </Mutation>
                                  </TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </div>
                    ))}
                  </Paper>
                  <StationCheckQuestionSection stationId={station.id} />
                </>
              </Loader>
            )
          }}
        </Query>
      )}
    </StationPage>
  )
}

export default StationSettingsPage
